import ApplicantsTable from "./ApplicantsTable.component.jsx";

export default ApplicantsTable;